import { render, staticRenderFns } from "./CityProject.vue?vue&type=template&id=278a12dd&scoped=true&"
import script from "./CityProject.vue?vue&type=script&lang=js&"
export * from "./CityProject.vue?vue&type=script&lang=js&"
import style0 from "./CityProject.vue?vue&type=style&index=0&id=278a12dd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278a12dd",
  null
  
)

export default component.exports